import type { ExternalShippingCarrierAddress } from "@jti/commerce-types";

import type { SelectedShippingAddress } from "../../ShippingForm.types";

export const getExternalShippingCarrierMagentoAddress = (
  externalShippingProviderAddress: ExternalShippingCarrierAddress
): SelectedShippingAddress => {
  const { storeId, storeName, streetName, postCode, city, countryCode, countryName, streetNumber } =
    externalShippingProviderAddress;

  return {
    isPickupAddress: true,
    pickupInformation: {
      store_id: storeId,
      store_name: storeName,
    },
    streetNumber: streetNumber || "",
    streetName,
    city,
    countryCode,
    countryName,
    streetAdditional: "",
    postcode: postCode,
  };
};
